import React from 'react'
import PropTypes from 'prop-types'

import Navigation from '../Navigation'

const Header = () => {
    return (
        <header id="MainHeader">
            <Navigation />
        </header>
    )
}

Header.propTypes = {

}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx